import type {
  AutoApprovalRule,
  AutoApprover,
} from "@p0security/shared/types/policy/types";
import { Select } from "@p0security/ui";
import {
  StyledFormItem,
  standardFormItemCols,
} from "components/common/forms/styles";
import { useAutoSelectSingleOption } from "hooks/useAutoSelectSingleOption";
import { useCallback, useMemo } from "react";

const labels: Record<AutoApprover, string> = {
  "grafana-irm": "Grafana IRM",
  incidentio: "Incident.io",
  pagerduty: "PagerDuty",
};

export const OnCallAllow: React.FC<{
  value: AutoApprovalRule;
  installed: AutoApprover[];
  onChange: (rule: AutoApprovalRule) => void;
}> = ({ installed, value, onChange }) => {
  const installedOptions = useMemo(
    () => installed.map((key) => ({ value: key, label: labels[key] })),
    [installed]
  );

  const handleSelectApprover = useCallback(
    (integration: AutoApprover) => {
      onChange({ ...value, type: "auto", integration });
    },
    [onChange, value]
  );

  const { locked: integrationLocked } = useAutoSelectSingleOption(
    installedOptions,
    value.integration,
    handleSelectApprover
  );

  return (
    <>
      {installedOptions && (
        <StyledFormItem {...standardFormItemCols} label="Integration">
          <Select<AutoApprover>
            className={integrationLocked ? "auto-locked-select" : undefined}
            options={installedOptions}
            onSelect={handleSelectApprover}
            value={value.integration}
            disabled={integrationLocked}
          />
        </StyledFormItem>
      )}
    </>
  );
};
